import { render, staticRenderFns } from "./DriverForm.vue?vue&type=template&id=19f7f6ea&scoped=true"
import script from "./DriverForm.vue?vue&type=script&lang=js"
export * from "./DriverForm.vue?vue&type=script&lang=js"
import style0 from "./DriverForm.vue?vue&type=style&index=0&id=19f7f6ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f7f6ea",
  null
  
)

export default component.exports